import { MenuIconKey } from 'lib/menuIcons';
import { ThemeMenuIcon } from 'components/ThemeMenuIcon/ThemeMenuIcon';
import { useNavigate } from 'react-router-dom';
import styles from './MobileMenuItem.module.css';
import { useExternalNavigate } from 'hooks/useExternalNavigate';

export interface MobileMenuItemProps {
  iconKey: MenuIconKey;
  label: string;
  destinationUrl?: string;
  external?: boolean;
  onClickAction?: () => void;
}

export const MobileMenuItem = ({
  iconKey,
  label,
  destinationUrl = '',
  external = false,
  onClickAction = () => {},
}: MobileMenuItemProps) => {
  const navigate = useNavigate();
  const externalNavigate = useExternalNavigate(destinationUrl, '_blank');

  const icon = (
    <span className={styles.iconSlot}>
      <ThemeMenuIcon icon={iconKey} alt={label} variant="grid" />
    </span>
  );

  const handleNavigation = () => {
    if (external) {
      externalNavigate.navigate();
    } else {
      navigate(destinationUrl);
    }
  };

  if (destinationUrl) {
    return (
      <span
        onClick={handleNavigation}
        className={styles.wrapper}
        data-key={iconKey}
      >
        {icon}
        <label>{label}</label>
      </span>
    );
  }

  return (
    <button
      className={styles.wrapper}
      data-key={iconKey}
      onClick={() => {
        onClickAction();
      }}
    >
      {icon}
      <label>{label}</label>
    </button>
  );
};
